export function moneyString (m){
  if(m===null) return ''
  return moneyStringFull(m.amount/100, m.currency)}
export function moneyStringFull (amount, currency){
  return moneyJustDigits(amount)+' '+currency
}
export function moneyStringWithoutCurrency(m){
  if(m===null) return ''
  return moneyJustDigits(m.amount/100)
}
export function moneyJustDigits(amount){
  return Number.parseFloat(amount).toLocaleString('en', {minimumFractionDigits:2})
}

export function amountFromMoneyString (m){
  return Number.parseFloat(m)*100;
}
export function filterAndChangeMoneyStrings(object, allowed, money){
  return Object.keys(object).filter(key=>allowed.includes(key))
    .reduce((filtered, key)=>{
      return {...filtered, 
        [key]: money.includes(key)?
          amountFromMoneyString(object[key]):object[key]}
    },{});
    
}
export function can(action, resource){
  if(permissions===null) return false
  if(typeof(permissions[resource])==='undefined') return false
  return permissions[resource].includes(action)
}

let Validation = function(){
  var errors = [];
  return {
    rule(valid, invalidMessage){
      if(!valid) errors.push(invalidMessage)
    },
    validate: function (){
      return {
        valid: errors.length==0,
        messageBag: errors
      }
    }
  }
}
export {Validation};
